import ObexRequestsHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { DepreciationMethod, DepreciationMethodPayload } from '../types/DepreciationMethod.types';
import { getAccessToken, buildQuery, unwrapList, unwrapRecord, unwrapError } from './apiUtils';

// Igual que cost_centers: el backend solo expone list y create.
const ROUTES = {
  list:   '/depreciation_methods_list',
  create: '/depreciation_methods_create'
};

export const mapDepreciationMethod = (raw: any): DepreciationMethod => ({
  id:            String(raw.id),
  code:          raw.code || '',
  name:          raw.name || '',
  methodType:    raw.method_type === 'declining_balance' ? 'declining_balance' : 'straight_line',
  annualRatePct: isNaN(Number(raw.annual_rate_pct)) ? 0 : Number(raw.annual_rate_pct),
  status:        raw.status === 'inactive' ? 'inactive' : 'active'
});

// depreciation_methods/list.avap no acepta paginación, solo status y search.
export const listDepreciationMethods = async (
  options: { status?: string; search?: string } = {}
): Promise<DepreciationMethod[]> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');

  const query = buildQuery({
    access_token: token,
    status:       options.status,
    search:       options.search
  });

  const res = await ObexRequestsHandlerP80.get(`${ROUTES.list}${query}`);
  return unwrapList(res).map(mapDepreciationMethod);
};

export const createDepreciationMethod = async (
  payload: DepreciationMethodPayload
): Promise<DepreciationMethod> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');

  const query = buildQuery({
    access_token:    token,
    code:            payload.code,
    name:            payload.name,
    method_type:     payload.methodType,
    annual_rate_pct: payload.annualRatePct,
    status:          payload.status || 'active'
  });

  const res = await ObexRequestsHandlerP80.get(`${ROUTES.create}${query}`);
  const record = unwrapRecord(res);
  if (!record) throw new Error(unwrapError(res, 'Error al dar de alta la clave de amortización.'));
  return mapDepreciationMethod(record);
};
